<template>
  <IncidentForm v-model="incident" editting @save="saveEdit" @cancel="emits('closeEditDetailsEvent')"></IncidentForm>
</template>

<script setup lang="ts">
// Frameworks Import
import { ref } from 'vue'

//Services import
import { useVModel } from '@vueuse/core'

import { updateIncident } from '@/services/api/incidents'
import type { Incident } from '@/types/Incident'
import emitter from '@/utils/EventBus'

import IncidentForm from '../../Incident/IncidentForm.vue'

const props = defineProps<{ modelValue: Incident }>()

const emits = defineEmits<{
  (event: 'update:modelValue', v: Incident): void
  (event: 'closeEditDetailsEvent'): void
}>()

const incident = useVModel(props, 'modelValue', emits, { deep: true })

const loading = ref(false as boolean)

async function saveEdit() {
  loading.value = true
  try {
    await updateIncident(incident.value as Incident)
    emits('update:modelValue', incident.value)
  } catch (ex) {
    console.error(ex)
  } finally {
    loading.value = false
    emitter.emit('save', { incident: incident })
  }
  emits('closeEditDetailsEvent')
}
</script>

<style lang="scss" scoped>
.overflow {
  overflow-y: scroll;
}
</style>
